var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserDefaultAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 15.5,
    fill: "#F5F5F5",
    stroke: "#DBDBDB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3346 22.3225V20.9696C21.3346 20.2519 21.0537 19.5637 20.5536 19.0562C20.0535 18.5488 19.3752 18.2637 18.668 18.2637H13.3346C12.6274 18.2637 11.9491 18.5488 11.449 19.0562C10.9489 19.5637 10.668 20.2519 10.668 20.9696V22.3225",
    stroke: "#8F8F8F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9987 15.5582C17.4715 15.5582 18.6654 14.3468 18.6654 12.8524C18.6654 11.3579 17.4715 10.1465 15.9987 10.1465C14.5259 10.1465 13.332 11.3579 13.332 12.8524C13.332 14.3468 14.5259 15.5582 15.9987 15.5582Z",
    stroke: "#8F8F8F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserDefaultAvatar);
export default __webpack_public_path__ + "static/media/user_default_avatar.e6fa66068066d9ed5de3c874f8ecc77d.svg";
export { ForwardRef as ReactComponent };